
shoppingActionsJS={

	langId: WCParamJS.langId,

	storeId: WCParamJS.storeId,

	catalogId: WCParamJS.catalogId,

	userType:WCParamJS.userType,

	baseItemAddedToCart:false,

	entitledItems:[],

    entitledItemJsonObject: null,

	selectedAttributesList:new Object(),

	moreInfoUrl :"",

	isPopup : false,

	displayPriceRange : true,

	itemPriceJsonOject : [],

	itemImageJsonOject : [],

	allSwatchesArrayList : new Object(),

	skuImageId:"",

	cookieKeyPrefix: "CompareItems_",

	cookieDelimiter: ";",

	currentNumberOfItemsInCompareZone: 0,

	currentNumberOfCatEntryIds: 1,

	maxNumberProductsAllowedToCompare: 4,

	minNumberProductsAllowedToCompare: 2,

	baseCatalogEntryId: 0,

	selectedProducts: new Object(),

	productList: new Object(),

	currencySymbol: WCParamJS.currencySymbol,

	compareReturnName: "",
	searchTerm: "",

		search01: "'",

		search02: '"',

		replaceStr01: /\\\'/g,

		replaceStr02: /\\\"/g,

		ampersandChar: /&/g,

		ampersandEntityName: "&amp;" ,

	productAddedList: new Object(),	

		setCompareReturnName:function(compareReturnName){
		this.compareReturnName = compareReturnName;
	},

		setSearchTerm:function(searchTerm){
		this.searchTerm = searchTerm;
	},

		setCommonParameters:function(langId,storeId,catalogId,userType,currencySymbol){
		this.langId = langId;
		this.storeId = storeId;
		this.catalogId = catalogId;
		this.userType = userType;
		this.currencySymbol = currencySymbol;
	},

		setEntitledItems : function(entitledItemArray){
		this.entitledItems = entitledItemArray;
	},

		getCatalogEntryId : function(entitledItemId){
		var attributeArray = [];
		var selectedAttributes = this.selectedAttributesList[entitledItemId];
		for(attribute in selectedAttributes){
			attributeArray.push(attribute + "_" + selectedAttributes[attribute]);
		}
		return this.resolveSKU(attributeArray);
	},

	getCatalogEntryIdforProduct : function(selectedAttributes){
		var attributeArray = [];
		for(attribute in selectedAttributes){
			attributeArray.push(attribute + "_" + selectedAttributes[attribute]);
		}
		return this.resolveSKU(attributeArray);
	},

    getEntitledItemJsonObject: function () {
    	return this.entitledItemJsonObject;
    },

	resolveSKU : function(attributeArray){

		var catentry_id = "";
		var attributeArrayCount = attributeArray.length;

		if(this.entitledItems.length == 1){
			return this.entitledItems[0].catentry_id;
		}
		for(x in this.entitledItems){
			var catentry_id = this.entitledItems[x].catentry_id;
			var Attributes = this.entitledItems[x].Attributes;
			var attributeCount = 0;
			for(index in Attributes){
				attributeCount ++;
			}

			if (attributeArrayCount == 0 && attributeCount == 0){
				return catentry_id;
			}
			if(attributeCount != 0 && attributeArrayCount >= attributeCount){
				var matchedAttributeCount = 0;

				for(attributeName in attributeArray){
					var attributeValue = attributeArray[attributeName];
					if(attributeValue in Attributes){
						matchedAttributeCount ++;
					}
				}

								if(attributeCount == matchedAttributeCount){
					return catentry_id;
				}
			}
		}
		return null;
	},

	setSelectedAttribute : function(selectedAttributeName , selectedAttributeValue, entitledItemId, skuImageId, imageField){ 
		var selectedAttributes = this.selectedAttributesList[entitledItemId];
		if(selectedAttributes == null){
			selectedAttributes = new Object();
		}
		selectedAttributeValue = selectedAttributeValue.replace(this.replaceStr01, this.search01);
		selectedAttributeValue = selectedAttributeValue.replace(this.replaceStr02, this.search02);
		selectedAttributeValue = selectedAttributeValue.replace(this.ampersandChar, this.ampersandEntityName);
		selectedAttributes[selectedAttributeName] = selectedAttributeValue;
		this.moreInfoUrl=this.moreInfoUrl+'&'+selectedAttributeName+'='+selectedAttributeValue;
		this.selectedAttributesList[entitledItemId] = selectedAttributes;		
		this.changeProdImage(entitledItemId, selectedAttributeName, selectedAttributeValue, skuImageId, imageField);		
	},

	setSelectedAttributeOfProduct : function(productId,selectedAttributeName,selectedAttributeValue, isSingleSKU){

				var selectedAttributesForProduct = null;

		if(this.selectedProducts[productId]){
			selectedAttributesForProduct = this.selectedProducts[productId];
		} else {
			selectedAttributesForProduct = new Object();
		}

		if(null != selectedAttributeName && '' != selectedAttributeName){
			selectedAttributesForProduct[selectedAttributeName] = selectedAttributeValue;
		}
		this.selectedProducts[productId] = selectedAttributesForProduct;

		var entitledItemJSON = eval('('+ dojo.byId("entitledItem_"+productId).innerHTML +')');

		this.setEntitledItems(entitledItemJSON);

				var catalogEntryId = this.getCatalogEntryIdforProduct(selectedAttributesForProduct);

				if(catalogEntryId == null) {
			catalogEntryId = 0;
		} else {
			this.changePrice("entitledItem_"+productId, false, true, productId);

			if(MerchandisingAssociationJS != null){
				if(MerchandisingAssociationJS.baseItemParams != null){
					if(MerchandisingAssociationJS.baseItemParams.type=='BundleBean'){
						for(idx=0;idx<MerchandisingAssociationJS.baseItemParams.components.length;idx++){
							if(productId == MerchandisingAssociationJS.baseItemParams.components[idx].productId){
								MerchandisingAssociationJS.baseItemParams.components[idx].id = catalogEntryId;
							}
						}
					}
				}
			}			
		}
		var productDetails = null;
		if(this.productList[productId]){
			productDetails = this.productList[productId];
		} else {
			productDetails = new Object();
			this.productList[productId] = productDetails;
			productDetails.baseItemId = productId;
		}

				productDetails.id = catalogEntryId;
		if(productDetails.quantity){
			dojo.topic.publish("Quantity_Changed", dojo.toJson(productDetails));
		}

				if(!isSingleSKU){
			if (catalogEntryId != 0) {
				dojo.topic.publish('DefiningAttributes_Resolved_'+productId, catalogEntryId, productId);
			}
		}
	},

	Add2ShopCartAjax : function(entitledItemId,quantity,isPopup,customParams)
	{	
		var entitledItemJSON;
		var isRDAddOn = false;

				if (dojo.byId(entitledItemId)!=null) {
			 entitledItemJSON = eval('('+ dojo.byId(entitledItemId).innerHTML +')');
		}else{
			entitledItemJSON = this.getEntitledItemJsonObject(); 
		}
		if (customParams != null && customParams != 'undefined') {
			if (customParams['catalogEntryType'] == 'repeatDeliveryAddOn') {
				isRDAddOn = true;	
			}
		}
		this.setEntitledItems(entitledItemJSON);
		var catalogEntryId = this.getCatalogEntryId(entitledItemId);

				if(catalogEntryId!=null){
			var productId = entitledItemId.substring(entitledItemId.indexOf("_")+1);
			if (isRDAddOn) {
				this.AddItem2RecurringOrderAjax(catalogEntryId , quantity, customParams, productId);
			}
			else {
				this.AddItem2ShopCartAjax(catalogEntryId , quantity, customParams, productId);
				this.baseItemAddedToCart=true;				
			}
			if(dijit.byId('second_level_category_popup') != null){
				hidePopup('second_level_category_popup');
			}
		}
		else if (isPopup == true){
			dojo.byId('second_level_category_popup').style.zIndex = '1';
			MessageHelper.formErrorHandleClient('addToCartLinkAjax', storeNLS['ERR_RESOLVING_SKU']);			
		} 
		else {
			MessageHelper.displayErrorMessage(storeNLS['ERR_RESOLVING_SKU']);
			this.baseItemAddedToCart=false;
		}
		try{
			var omnitureEnabled;
			if(dojo.byId("omnitureEnabled") != undefined && dojo.byId("omnitureEnabled") != null)
				omnitureEnabled = dojo.byId("omnitureEnabled").value;

						if(omnitureEnabled != "undefined" && null != omnitureEnabled && omnitureEnabled !='' && omnitureEnabled == 'true'){
				if (customParams != null && customParams != 'undefined') {
		             if (customParams['catalogEntryType'] == 'donation' || customParams['catalogEntryType'] == 'donation-page') {

		            	 		            	 var cartEventDetails = {};
		            	 cartEventDetails["event_name"] = "cart_add_donation";		
		            	 for(var x in entitledItemJSON){
		            		 if(entitledItemJSON[x].catentry_id == catalogEntryId )
		            			 cartEventDetails["cart_donation_amount"] = entitledItemJSON[x].catentry_name;
		            	 }


			             			            			            	 var cartOrderId = dojo.cookie("WC_CartOrderId_10151");
		            	 if(cartOrderId != null && cartOrderId != "")
								cartEventDetails["cart_id"] = cartOrderId;	
		            	 pushEvent(cartEventDetails,"addDonationBtn");

		            	 		             }
		         }
			}
			var adobeDataLayerEnabled = $('#adobeDataLayerEnabled').val();
			if (adobeDataLayerEnabled == 'true') {
				var donationAmt;
				for(var x in entitledItemJSON){
					if(entitledItemJSON[x].catentry_id == catalogEntryId )
						donationAmt = entitledItemJSON[x].catentry_name;
            	}
				buildAdobeCartPromoCTAJSON("applyDonation",donationAmt);
			}

					}catch(err){
			console.log("issue in tagging "+err);
		}
	},

		Add2RecurringOrderAjax : function(entitledItemId, quantity, isPopup, customParams) {

				this.Add2ShopCartAjax(entitledItemId, quantity, isPopup, customParams);
	},

		AddItem2ShopCartAjax : function(catEntryIdentifier, quantity, customParams, productId)
	{
		var params = [];
		params.storeId		= this.storeId;
		params.catalogId	= this.catalogId;
		params.langId		= this.langId;
		params.orderId		= ".";
		if(CheckoutHelperJS.shoppingCartPage){	
			params.calculationUsage = "-1,-2,-5,-6,-7";
		}else{
			params.calculationUsage = "-1,-3,-4,-5,-6,-7";
		}

						params.inventoryValidation = "true";
		var ajaxShopCartService = "AddOrderItem";
		var isRDAddOn = false;

				this.productAddedList = new Object();
		if(dojo.isArray(catEntryIdentifier) && dojo.isArray(quantity)){
			for(var i=0; i<catEntryIdentifier.length; i++){
				if(!isPositiveInteger(quantity[i])){
					MessageHelper.displayErrorMessage(storeNLS['QUANTITY_INPUT_ERROR']);
					return;
				}
				params["catEntryId_" + (i+1)] = catEntryIdentifier[i];
				params["quantity_" + (i+1)]	= quantity[i];
			}
		}
		else{
			if(!isPositiveInteger(quantity)){
				MessageHelper.displayErrorMessage(storeNLS['QUANTITY_INPUT_ERROR']);
				return;
			}
			params.catEntryId	= catEntryIdentifier;
			params.quantity		= quantity;

						var selectedAttrList = new Object();
			for(attr in this.selectedAttributesList['entitledItem_'+productId]){
				selectedAttrList[attr] = this.selectedAttributesList['entitledItem_'+productId][attr];
			}			

						if(productId == undefined){
				this.saveAddedProductInfo(quantity, catEntryIdentifier, catEntryIdentifier, selectedAttrList);
			} else {
				this.saveAddedProductInfo(quantity, productId, catEntryIdentifier, selectedAttrList);
			}
		}		

		if(customParams != null && customParams != 'undefined'){
			for(i in customParams){
				params[i] = customParams[i];
			}
			if (customParams['catalogEntryType'] == 'dynamicKit' ) {
				ajaxShopCartService = "AddPreConfigurationToCart";
			}
			else if (customParams['catalogEntryType'] == 'donation') {
				ajaxShopCartService = "AddDonationItem";
			}
			else if (customParams['catalogEntryType'] == 'repeatDeliveryAddOn') {
				isRDAddOn = true;	
				ajaxShopCartService = 'AddOrderItemToOrder';	
				params.orderId = '**'; 
			}
		}

		var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
		if (contractIdElements != null && contractIdElements != "undefined") {
			for (i=0; i<contractIdElements.length; i++) {
				if (contractIdElements[i].checked) {
					params.contractId = contractIdElements[i].value;
					break;
				}
			}
		}

		if(!submitRequest()){
			return;
		}   
		cursor_wait();	

				wc.service.invoke(ajaxShopCartService, params);
		if (!isRDAddOn) {
			this.baseItemAddedToCart=true;
			if(document.getElementById("headerShopCartLink")&&document.getElementById("headerShopCartLink").style.display != "none") {
				document.getElementById("headerShopCart").focus();
			}
			else {
				if(document.getElementById("headerShopCart1")){
					document.getElementById("headerShopCart1").focus();
				}
			}			
		}
	},

		AddItem2RecurringOrderAjax : function(catEntryIdentifier, quantity, customParams, productId) {

				this.AddItem2ShopCartAjax(catEntryIdentifier, quantity, customParams, productId);
	},

	AddBundle2ShopCartAjax : function(){
		var ajaxShopCartService = "AddOrderItem";
		var params = [];

		params.storeId		= this.storeId;
		params.catalogId	= this.catalogId;
		params.langId		= this.langId;
		params.orderId		= ".";
		params.calculationUsage = "-1,-2,-5,-6,-7";
		params.inventoryValidation = "true";

				var idx = 1;
		this.productAddedList = new Object();

				for(productId in this.productList){
			var productDetails = this.productList[productId];
			var quantity = dojo.number.parse(productDetails.quantity);
			if (quantity == 0) {
				continue;
			}
			if(productDetails.id == 0){
				MessageHelper.displayErrorMessage(storeNLS['ERR_RESOLVING_SKU']);
				return;
			}
			if(isNaN(quantity) || quantity < 0){
				MessageHelper.displayErrorMessage(storeNLS['QUANTITY_INPUT_ERROR']);
				return;
			}

			params["catEntryId_" + idx] = productDetails.id;
			params["quantity_" + idx++] = quantity;
			this.baseItemAddedToCart=true;

							this.saveAddedProductInfo(quantity, productId, productDetails.id, this.selectedProducts[productId]);
		}

		if(!submitRequest()){
			return;
		}   		
		cursor_wait();		
		wc.service.invoke(ajaxShopCartService, params);

	},

			resetProductAddedList: function () {
		shoppingActionsJS.productAddedList = new Object();
	},
	saveAddedProductInfo:function(quantity, productId, skuId, attrList){

			var productName = "";
		if(document.getElementById("ProductInfoName_"+productId) != null){
			productName = document.getElementById("ProductInfoName_"+productId).value;
		} else if(document.getElementById("ProductInfoName_"+skuId) != null){
			productName = document.getElementById("ProductInfoName_"+skuId).value;
		}

				var productThumbnail = "";
		if(document.getElementById("ProductInfoImage_"+productId) != null){
			productThumbnail = document.getElementById("ProductInfoImage_"+productId).value;
		} else if(document.getElementById("ProductInfoImage_"+skuId) != null){
			productThumbnail = document.getElementById("ProductInfoImage_"+skuId).value;
		}

				var productPrice = "";
		if(document.getElementById('ProductInfoPrice_'+productId) != null){
			productPrice = document.getElementById('ProductInfoPrice_'+productId).value;
		} else if(document.getElementById('ProductInfoPrice_'+skuId) != null){
			productPrice = document.getElementById('ProductInfoPrice_'+skuId).value;
		}

				var productAdded = [productName, productThumbnail, productPrice, quantity, attrList];
		if(productId != skuId){
			this.productAddedList[skuId] = productAdded;
		} else {
			this.productAddedList[productId] = productAdded;
		}

				dojo.topic.publish("ProductInfo_Added", this.productAddedList);
	},


	setSKUImageId:function(skuImageId){
		this.skuImageId = skuImageId;
	},

	getImageForSKU : function(entitledItemId, imageField){
		var attributeArray = [];
		var selectedAttributes = this.selectedAttributesList[entitledItemId];
		for(attribute in selectedAttributes){
			attributeArray.push(attribute + "_" + selectedAttributes[attribute]);
		}
		return this.resolveImageForSKU(attributeArray, imageField);
	},

	resolveImageForSKU : function(attributeArray, imageField){

		var imagePath = "";
		var attributeArrayCount = attributeArray.length;

				for(x in this.entitledItems){
			if(null != imageField){
				var imagePath = this.entitledItems[x][imageField];
			} else {
			var imagePath = this.entitledItems[x].ItemImage467;
			}

						var Attributes = this.entitledItems[x].Attributes;
			var attributeCount = 0;
			for(index in Attributes){
				attributeCount ++;
			}

			if (attributeArrayCount == 0 && attributeCount == 0){
				return imagePath;
			}
			if(attributeCount != 0 && attributeArrayCount >= attributeCount){
				var matchedAttributeCount = 0;

				for(attributeName in attributeArray){
					var attributeValue = attributeArray[attributeName];
					if(attributeValue in Attributes){
						matchedAttributeCount ++;
					}
				}

								if(attributeCount == matchedAttributeCount){
					var imageArray = [];
					imageArray.push(imagePath);
					imageArray.push(this.entitledItems[x].ItemThumbnailImage);
					if(this.entitledItems[x].ItemAngleThumbnail != null && this.entitledItems[x].ItemAngleThumbnail != undefined){
						imageArray.push(this.entitledItems[x].ItemAngleThumbnail);
						imageArray.push(this.entitledItems[x].ItemAngleFullImage);
					}
					return imageArray;
				}
			}
		}
		return null;
	},


	changeViewImages : function(itemAngleThumbnail, itemAngleFullImage){
		var imageCount = 0;
		for (x in itemAngleThumbnail) {
			var prodAngleCount = imageCount;
			imageCount++;
			if(null != dojo.byId("WC_CachedProductOnlyDisplay_images_1_" + imageCount)){
				dojo.byId("WC_CachedProductOnlyDisplay_images_1_" + imageCount).src = itemAngleThumbnail[x];
			}
			if(null != dojo.byId("WC_CachedProductOnlyDisplay_links_1_" + imageCount)){
				dojo.byId("WC_CachedProductOnlyDisplay_links_1_" + imageCount).href =
					"JavaScript:changeThumbNail('productAngleLi" + prodAngleCount + "','" + itemAngleFullImage[x] + "');";
			}

						if(null != dojo.byId("productAngleLi" + prodAngleCount) && dojo.byId("productAngleLi" + prodAngleCount).className == "selected"){
				changeThumbNail("productAngleLi" + prodAngleCount, itemAngleFullImage[x]);
			}
		}
	},


	changeProdImage: function(entitledItemId, swatchAttrName, swatchAttrValue, skuImageId, imageField){
		if (dojo.byId(entitledItemId)!=null) {
			 entitledItemJSON = eval('('+ dojo.byId(entitledItemId).innerHTML +')');
		}

		this.setEntitledItems(entitledItemJSON);
		var productId = entitledItemId.substring(entitledItemId.indexOf("_")+1);

		var skuImage = null;
		var imageArr = shoppingActionsJS.getImageForSKU(entitledItemId, imageField);
		if(imageArr != null){
			skuImage = imageArr[0];
		}

				if(skuImageId != undefined){
			this.setSKUImageId(skuImageId);
		}

				if(skuImage != null){
			if(dojo.byId(this.skuImageId) != null){
				document.getElementById(this.skuImageId).src = skuImage;	
				if(document.getElementById("ProductInfoImage_"+productId) != null){
					document.getElementById("ProductInfoImage_"+productId).value = skuImage;
				}				

								var itemAngleThumbnail = imageArr[2];
				var itemAngleFullImage = imageArr[3];
				if(itemAngleThumbnail != null && itemAngleThumbnail != undefined){
					shoppingActionsJS.changeViewImages(itemAngleThumbnail, itemAngleFullImage);
				}
			}
		} else {
			var imageFound = false;
			for (x in this.entitledItems) {
				var Attributes = this.entitledItems[x].Attributes;
				if(null != imageField){
					var itemImage = this.entitledItems[x][imageField];
				} else {
				var itemImage = this.entitledItems[x].ItemImage467;
				}


												var itemAngleThumbnail = this.entitledItems[x].ItemAngleThumbnail;
				var itemAngleFullImage = this.entitledItems[x].ItemAngleFullImage;

					for(y in Attributes){
					var index = y.indexOf("_");
					var entitledSwatchName = y.substring(0, index);
					var entitledSwatchValue = y.substring(index+1);	

										if (entitledSwatchName == swatchAttrName && entitledSwatchValue == swatchAttrValue) {
						if(null != dojo.byId(this.skuImageId)){
							dojo.byId(this.skuImageId).src = itemImage;
							if(document.getElementById("ProductInfoImage_"+productId) != null){
								document.getElementById("ProductInfoImage_"+productId).value = itemImage;
							}
						}	
						if(itemAngleThumbnail != null && itemAngleThumbnail != undefined){
							shoppingActionsJS.changeViewImages(itemAngleThumbnail, itemAngleFullImage);
						}
						imageFound = true;
						break;
					}
				}

								if(imageFound){
					break;
				}
			}
		}
	},

	updateSwatchListView: function(){
			var swatchArray = dojo.query("a[id^='swatch_array_']");
			for(var i = 0; i<swatchArray.length; i++){
				var swatchArrayElement = swatchArray[i];
				eval(dojo.attr(swatchArrayElement,"href"));
			}

						var swatchSkuImage = dojo.query("a[id^='swatch_setSkuImage_']");
			for(var i = 0; i<swatchSkuImage.length; i++){
				var swatchSkuImageElement = swatchSkuImage[i];
				eval(dojo.attr(swatchSkuImageElement,"href"));
			}			

						var swatchDefault = dojo.query("a[id^='swatch_selectDefault_']");
			for(var i = 0; i<swatchDefault.length; i++){
				var swatchDefaultElement = swatchDefault[i];
				eval(dojo.attr(swatchDefaultElement,"href"));
			}		
	},

	selectSwatch: function(selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable, skuImageId, imageField) {
		if(dojo.hasClass("swatch_" + entitledItemId + "_" + selectedAttributeValue, "color_swatch_disabled")){
			return;
		}
		var selectedAttributes = this.selectedAttributesList[entitledItemId];
		for (attribute in selectedAttributes) {
			if (attribute == selectedAttributeName) {
				if (selectedAttributes[attribute] != selectedAttributeValue) {
					var swatchElement = dojo.byId("swatch_" + entitledItemId + "_" + selectedAttributes[attribute]);
					swatchElement.className = "color_swatch";
					swatchElement.src = swatchElement.src.replace("_disabled.png","_enabled.png");

					dojo.byId("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]).title = swatchElement.alt;
				}
			}
			if (document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]) != null) {
				document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]).setAttribute("aria-checked", "false");
			}
		}
		this.makeSwatchSelection(selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable, skuImageId, imageField);
	},

	makeSwatchSelection: function(swatchAttrName, swatchAttrValue, entitledItemId, doNotDisable, skuImageId, imageField) {
		this.setSelectedAttribute(swatchAttrName, swatchAttrValue, entitledItemId, skuImageId, imageField);
		document.getElementById("swatch_" + entitledItemId + "_" + swatchAttrValue).className = "color_swatch_selected";
		document.getElementById("swatch_link_" + entitledItemId + "_" + swatchAttrValue).setAttribute("aria-checked", "true");
		document.getElementById("swatch_selection_label_" + entitledItemId + "_" + swatchAttrName).className = "header color_swatch_label";
		if (document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).style.display == "none") {
			document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).style.display = "inline";
		}
		document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).innerHTML = swatchAttrValue;
		this.updateSwatchImages(swatchAttrName, entitledItemId, doNotDisable,imageField);
	},

	addToAllSwatchsArray: function(swatchName, swatchValue, swatchImg1, entitledItemId) {
		var swatchList = this.allSwatchesArrayList[entitledItemId];
		if(swatchList == null){
			swatchList = new Array();;
		}
		if (!this.existInAllSwatchsArray(swatchName, swatchValue, swatchList)) {
			var swatchRecord = new Array();
			swatchRecord[0] = swatchName;
			swatchRecord[1] = swatchValue;
			swatchRecord[2] = swatchImg1;
			swatchRecord[4] = document.getElementById("swatch_link_" + entitledItemId + "_" + swatchValue).onclick;
			swatchList.push(swatchRecord);
			this.allSwatchesArrayList[entitledItemId] = swatchList;
		}
	},

	existInAllSwatchsArray: function(swatchName, swatchValue, swatchList) {
		for(var i=0; i<swatchList.length; i++) {
			var attrName = swatchList[i][0];
			var attrValue = swatchList[i][1];
			if (attrName == swatchName && attrValue == swatchValue) {
				return true;
			}
		}
		return false;
	},

	makeDefaultSwatchSelection: function(entitledItemId, doNotDisable) {
		if (this.entitledItems.length == 0) {
			if (dojo.byId(entitledItemId)!=null) {
				 entitledItemJSON = eval('('+ dojo.byId(entitledItemId).innerHTML +')');
			}
			this.setEntitledItems(entitledItemJSON);
		}

		for(x in this.entitledItems){
			var Attributes = this.entitledItems[x].Attributes;
			for(y in Attributes){
				var index = y.indexOf("_");
				var swatchName = y.substring(0, index);
				var swatchValue = y.substring(index+1);
				this.makeSwatchSelection(swatchName, swatchValue, entitledItemId, doNotDisable,imageField);
			}
			break;
		}
	},

	updateSwatchImages: function(selectedAttrName, entitledItemId, doNotDisable,imageField) {
		var swatchToUpdate = new Array();
		var selectedAttributes = this.selectedAttributesList[entitledItemId];
		var selectedAttrValue = selectedAttributes[selectedAttrName];
		var swatchList = this.allSwatchesArrayList[entitledItemId];

		for(var i=0; i<swatchList.length; i++) {
			var attrName = swatchList[i][0];
			var attrValue = swatchList[i][1];
			var attrImg1 = swatchList[i][2];
			var attrImg2 = swatchList[i][3];
			var attrOnclick = swatchList[i][4];

						if (attrName != doNotDisable && attrName != selectedAttrName) {
				var swatchRecord = new Array();
				swatchRecord[0] = attrName;
				swatchRecord[1] = attrValue;
				swatchRecord[2] = attrImg1;
				swatchRecord[4] = attrOnclick;
				swatchRecord[5] = false;
				swatchToUpdate.push(swatchRecord);
			}
		}

		for (x in this.entitledItems) {
			var Attributes = this.entitledItems[x].Attributes;

			for(y in Attributes){
				var index = y.indexOf("_");
				var entitledSwatchName = y.substring(0, index);
				var entitledSwatchValue = y.substring(index+1);	

				if (entitledSwatchName == selectedAttrName && entitledSwatchValue == selectedAttrValue) {
					for (z in Attributes) {
						var index2 = z.indexOf("_");
						var entitledSwatchName2 = z.substring(0, index2);
						var entitledSwatchValue2 = z.substring(index2+1);

												if(y != z){ 
							for (i in swatchToUpdate) {
								var swatchToUpdateName = swatchToUpdate[i][0];
								var swatchToUpdateValue = swatchToUpdate[i][1];

																if (entitledSwatchName2 == swatchToUpdateName && entitledSwatchValue2 == swatchToUpdateValue) {
									swatchToUpdate[i][5] = true;
								}
							}
						}
					}
				}
			}
		}

		var disabledAttributes = [];
		for (i in swatchToUpdate) {
			var swatchToUpdateName = swatchToUpdate[i][0];
			var swatchToUpdateValue = swatchToUpdate[i][1];
			var swatchToUpdateImg1 = swatchToUpdate[i][2];
			var swatchToUpdateImg2 = swatchToUpdate[i][3];
			var swatchToUpdateOnclick = swatchToUpdate[i][4];
			var swatchToUpdateEnabled = swatchToUpdate[i][5];		

						if (swatchToUpdateEnabled) {
				if(document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue).className != "color_swatch_selected"){
					var swatchElement = dojo.byId("swatch_" + entitledItemId + "_" + swatchToUpdateValue);
					swatchElement.className = "color_swatch";
					swatchElement.src = swatchElement.src.replace("_disabled.png","_enabled.png");

					dojo.byId("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).title = swatchElement.alt;
				}
				document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).setAttribute("aria-disabled", "false");
				document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).onclick = swatchToUpdateOnclick;
			} else {
				if(swatchToUpdateName != doNotDisable){
					var swatchElement = dojo.byId("swatch_" + entitledItemId + "_" + swatchToUpdateValue);
					var swatchLinkElement = dojo.byId("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue);
					swatchElement.className = "color_swatch_disabled";					
					swatchLinkElement.onclick = null;
					swatchElement.src = swatchElement.src.replace("_enabled.png","_disabled.png");

					var titleText = storeNLS["INV_ATTR_UNAVAILABLE"];
					swatchLinkElement.title = dojo.string.substitute(titleText,{0: swatchElement.alt});

										document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).setAttribute("aria-disabled", "true");

					if(selectedAttributes[swatchToUpdateName] == swatchToUpdateValue){
						disabledAttributes.push(swatchToUpdate[i]);
					}
				}
			}
		}

		for(i in disabledAttributes){
			var disabledAttributeName = disabledAttributes[i][0];
			var disabledAttributeValue = disabledAttributes[i][1];

			for (i in swatchToUpdate) {
				var swatchToUpdateName = swatchToUpdate[i][0];
				var swatchToUpdateValue = swatchToUpdate[i][1];
				var swatchToUpdateEnabled = swatchToUpdate[i][5];	

								if(swatchToUpdateName == disabledAttributeName && swatchToUpdateValue != disabledAttributeValue && swatchToUpdateEnabled){
						this.makeSwatchSelection(swatchToUpdateName, swatchToUpdateValue, entitledItemId, doNotDisable,imageField);
					break;
				}
			}
		}
	},

	changePrice : function(entitledItemId,isPopup,displayPriceRange,productId){
		this.displayPriceRange = displayPriceRange;
		this.isPopup = isPopup;
		var entitledItemJSON;

		if (dojo.byId(entitledItemId)!=null && !this.isPopup) {
			 entitledItemJSON = eval('('+ dojo.byId(entitledItemId).innerHTML +')');
		}else{
			entitledItemJSON = this.getEntitledItemJsonObject(); 
		}
		var catalogEntryId = null;
		this.setEntitledItems(entitledItemJSON);

				if(this.selectedProducts[productId]){
			var catalogEntryId = this.getCatalogEntryIdforProduct(this.selectedProducts[productId]);
		} else {
			var catalogEntryId = this.getCatalogEntryId(entitledItemId);
		}

				if(catalogEntryId!=null){
			if(this.itemPriceJsonOject[catalogEntryId] != null && this.itemPriceJsonOject[catalogEntryId] != 'undefined'){
				this.displayPrice(this.itemPriceJsonOject[catalogEntryId].catalogEntry,productId);
			}
			else{
				var parameters = {};
				parameters.storeId = this.storeId;
				parameters.langId= this.langId;
				parameters.catalogId= this.catalogId;
				parameters.catalogEntryId= catalogEntryId;
				parameters.productId = productId;

				dojo.xhrPost({
					url: getAbsoluteURL() + "GetCatalogEntryDetailsByIDView",				
					handleAs: "json-comment-filtered",
					content: parameters,
					service: this,
					load: shoppingActionsJS.displayPriceServiceResponse,
					error: function(errObj,ioArgs) {
						console.debug("ShoppingActions.changePrice: Unexpected error occurred during an xhrPost request.");
					}
				});
			}
		}
		else{
			console.debug("ShoppingActions.changePrice: all attributes are not selected.");
		}

					},

	 displayPriceServiceResponse : function(serviceResponse, ioArgs){
		var productId = ioArgs['args'].content['productId'];
		shoppingActionsJS.itemPriceJsonOject[serviceResponse.catalogEntry.catalogEntryIdentifier.uniqueID] = serviceResponse;

				shoppingActionsJS.displayPrice(serviceResponse.catalogEntry,productId);
	 },

	 displayImageServiceResponse : function(serviceResponse, ioArgs){
			shoppingActionsJS.itemImageJsonOject[serviceResponse.catalogEntry.catalogEntryIdentifier.uniqueID] = serviceResponse;

						shoppingActionsJS.displayImage(serviceResponse.catalogEntry);
	 },

	 displayImage : function(catEntry){
		var i = this.currentNumberOfCatEntryIds;
		var compareThumb_i = dojo.byId('compareThumb'+i);
		var compare1 = dojo.byId('compareThumb1');
		var compare2 = dojo.byId('compareThumb2');
		var compare3 = dojo.byId('compareThumb3');
		var compare4 = dojo.byId('compareThumb4');
		if(compare1.innerHTML.trim() == ''){
			i=1;
			compareThumb_i = dojo.byId('compareThumb'+i);
		}else if(compare2.innerHTML.trim() == ''){
			i=2;
			compareThumb_i = dojo.byId('compareThumb'+i);
		}else if(compare3.innerHTML.trim() == ''){
			i=3;
			compareThumb_i = dojo.byId('compareThumb'+i);
		}else if(compare4.innerHTML.trim() == ''){
			i=4;
			compareThumb_i = dojo.byId('compareThumb'+i);
		}
		var imagePresetSrc = catEntry.description[0].thumbnail + "?$ProductList-medium$"
		if (isCloudniaryEnabled()) {
			imagePresetSrc  = catEntry.description[0].thumbnail.replace('f_auto,q_auto', 'f_auto,q_auto,t_ProductList-medium');
		}
		compareThumb_i.innerHTML = "<img class='img-responsive' src='"+imagePresetSrc+"' id='compare_image_"+catEntry.catalogEntryIdentifier.uniqueID+"'/>";		
		var count=i;
		if(count>1){
			var compareurl = document.getElementById("compareProductsURL").value;
			document.getElementById("compare_link").setAttribute("onclick",compareurl);
			document.getElementById("compare_link").style.cursor="pointer";
			document.getElementById("compare_link").style.color="#00a3e0";
			$(".comparelink").tooltip("disable");
		}else{
			document.getElementById("compare_link").setAttribute("href","#");
			document.getElementById("compare_link").style.cursor="not-allowed";
			document.getElementById("compare_link").style.color="#808080";
			$(".comparelink").tooltip("enable");								
		}
		this.currentNumberOfCatEntryIds=this.currentNumberOfCatEntryIds+1;
	 },

	 displayPrice : function(catEntry,productId){

		var tempString;
		var popup = shoppingActionsJS.isPopup;

		if(popup == true){
			document.getElementById('productPrice').innerHTML = catEntry.offerPrice;
			document.getElementById('productName').innerHTML = catEntry.description[0].name;
			document.getElementById('productSKUValue').innerHTML = catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;
		}

				if(popup == false){
			var innerHTML = "";
			var listPrice = dojo.currency.parse(catEntry.listPrice,{symbol: this.currencySymbol});
			var offerPrice = dojo.currency.parse(catEntry.offerPrice,{symbol: this.currencySymbol});

						this.setPriceInProductList(productId,offerPrice);

						if(!catEntry.listPriced || listPrice <= offerPrice){
				innerHTML = "<span id='offerPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='price'>" + catEntry.offerPrice + "</span>";
			}
			else{
				innerHTML = "<span id='listPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='old_price'>" + catEntry.listPrice + "</span>"+
							"<span id='offerPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='price'>" + catEntry.offerPrice + "</span>";
			}
			document.getElementById('price_display_'+productId).innerHTML = innerHTML
				+ "<input type='hidden' id='ProductInfoPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' value='" + catEntry.offerPrice + "'/>";

						innerHTML = "";
			if(shoppingActionsJS.displayPriceRange == true){
				for(var i in catEntry.priceRange){
					if(catEntry.priceRange[i].endingNumberOfUnits == catEntry.priceRange[i].startingNumberOfUnits){
						tempString = storeNLS['PQ_PRICE_X'];
						innerHTML = innerHTML + "<p>" + dojo.string.substitute(tempString,{0: catEntry.priceRange[i].startingNumberOfUnits});
					}
					else if(catEntry.priceRange[i].endingNumberOfUnits != 'null'){
						tempString = storeNLS['PQ_PRICE_X_TO_Y'];
						innerHTML = innerHTML + "<p>" + dojo.string.substitute(tempString,{0: catEntry.priceRange[i].startingNumberOfUnits, 
							1: catEntry.priceRange[i].endingNumberOfUnits});
					}
					else{
						tempString = storeNLS['PQ_PRICE_X_OR_MORE'];
						innerHTML = innerHTML + "<p>" + dojo.string.substitute(tempString,{0: catEntry.priceRange[i].startingNumberOfUnits});
					}					
					innerHTML = innerHTML + " <span class='price'>" + catEntry.priceRange[i].localizedPrice + "</span></p>";
				}
			}
			var quantityDiscount = dojo.byId("productLevelPriceRange_"+productId);
			var itemQuantityDiscount = dojo.byId("itemLevelPriceRange_"+productId);

			if(null != quantityDiscount && null == itemQuantityDiscount){
				dojo.style(quantityDiscount, "display", ""); 
			}
			else if("" != innerHTML && null != itemQuantityDiscount){
				innerHTML = storeNLS['PQ_PURCHASE'] + innerHTML;
				itemQuantityDiscount.innerHTML = innerHTML;
				dojo.style(itemQuantityDiscount, "display", "");
				if(null != quantityDiscount){
					dojo.style(quantityDiscount, "display", "none");
				}
			}
			else if("" == innerHTML){
				if(null != itemQuantityDiscount){
					dojo.style(itemQuantityDiscount, "display", "none"); 
				}
				if(null != quantityDiscount){
					dojo.style(quantityDiscount, "display", ""); 
				}
			} 

			var productNameLink = dojo.query('#product_name_' + productId + ' > a');
			if(productNameLink.length == 1){
				productNameLink[0].innerHTML = catEntry.description[0].name;
			} else if(dojo.byId('product_name_'+productId)) {
				dojo.byId('product_name_'+productId).innerHTML = catEntry.description[0].name;
			}

						if(dojo.query("#widget_product_info_viewer > div[id^='PageHeading_']") != null){
				dojo.query("#widget_product_info_viewer > div[id^='PageHeading_']").forEach(function(node){
					if(node.childNodes != null && node.childNodes.length == 3){
						node.childNodes[1].innerHTML = catEntry.description[0].name;
					}
				});		
			}			
			if(document.getElementById("ProductInfoName_"+productId) != null){
				document.getElementById("ProductInfoName_"+productId).value = catEntry.description[0].name;
			}
			if(document.getElementById('product_shortdescription_'+productId)) {
				document.getElementById('product_shortdescription_'+productId).innerHTML = catEntry.description[0].shortDescription;
			}
			if(document.getElementById('product_SKU_'+productId)){
				document.getElementById('product_SKU_'+productId).innerHTML = storeNLS['SKU'] + " " + catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;
			}
		}
	 },

	showWCDialogPopup : function(widgetId){
		var popup = dijit.byId(widgetId); 
		if(popup != null){
			popup.closeButtonNode.style.display='none';
			popup.show();
		}
		else {
			console.debug(widgetId +" does not exist");
		}
	},

	notifyAttributeChange: function(catalogEntryID){
		this.baseCatalogEntryId = catalogEntryID;
		var selectedAttributes = this.selectedAttributesList["entitledItem_" + catalogEntryID];
		dojo.topic.publish('DefiningAttributes_Resolved_'+catalogEntryID, catalogEntryID, -1);
	},

	notifyQuantityChange: function(quantity){
		dojo.topic.publish("Quantity_Changed", quantity);
	},

	initCompare: function(fromPage){

		if(fromPage != 'search'){
			this.checkForCompare();

					} else {
			var cookieKey = this.cookieKeyPrefix + this.storeId;
			var newCookieValue = "";
			dojo.cookie(cookieKey, newCookieValue, {path:'/'});
		}

			},

	changeCompareBox: function(cbox,catEntryIdentifier) {
		box = document.getElementById(cbox);
		box.checked = !box.checked;
		this.addOrRemoveFromCompare(cox.checkedatEntryIdentifier,b);
	},

	addOrRemoveFromCompare: function(catEntryIdentifier,checked){
		if(checked){
			this.addToCompare(catEntryIdentifier);
		}
		else{
			this.removeFromCompare(catEntryIdentifier);
		}
	},
	addOrRemoveFromComparePetco: function(catEntryIdentifier,imgPath,checked){
		var sku = document.getElementById('sku_'+catEntryIdentifier).value;
		if(checked){
			if (sku != null && sku != "undefined") {
				var productCompareJSON = {"event_name":"product_compare","conversion_event_id" : "Product Compare", "conversion_category_id" : "Product Compare", "conversion_action_type" : "1", "product_sku" : sku};
				pushEvent(productCompareJSON);
			}
			this.addToComparePetco(catEntryIdentifier,imgPath);
		}
		else{
			this.removeFromComparePetco(catEntryIdentifier,imgPath);
			$("input").tooltip("disable");
		}
	},

	getCatentryDetails: function(catEntId){
		if(catEntId!=null){

			if(this.itemImageJsonOject[catEntId] != null && this.itemImageJsonOject[catEntId] != 'undefined'){

						this.displayImage(this.itemImageJsonOject[catEntId].catalogEntry);
			}
			else{
				var parameters = {};
				parameters.storeId = this.storeId;
				parameters.langId= this.langId;
				parameters.catalogId= this.catalogId;
				parameters.catalogEntryId= catEntId;

				dojo.xhrPost({
					url: getAbsoluteURL() + "GetCatalogEntryDetailsByIDView",
					sync: true,
					handleAs: "json-comment-filtered",
					content: parameters,
					service: this,
					load: shoppingActionsJS.displayImageServiceResponse,
					error: function(errObj,ioArgs) {
						console.debug("ShoppingActions.getCatentryDetails: Unexpected error occurred during an xhrPost request.");
					}
				});
			}
		}else{
			console.debug("ShoppingActions.getCatentryDetails: catEntId is null.");
		}
	},

	addToCompare:function(catEntryIdentifier){

				var cookieKey = this.cookieKeyPrefix + this.storeId;
		var cookieValue = dojo.cookie(cookieKey);

				if(cookieValue != null){
			if(cookieValue.indexOf(catEntryIdentifier) != -1 || catEntryIdentifier == null){
				MessageHelper.displayErrorMessage(storeNLS["COMPARE_ITEM_EXISTS"]);
				return;
			}
		}

				var currentNumberOfItemsInCompare = 0;
		if(cookieValue != null && cookieValue != ""){
			currentNumberOfItemsInCompare = cookieValue.split(this.cookieDelimiter).length;
		}

				if (currentNumberOfItemsInCompare < parseInt(this.maxNumberProductsAllowedToCompare)) {
			var newCookieValue = "";
			if(cookieValue == null || cookieValue == ""){
				newCookieValue = catEntryIdentifier;
			}
			else{
				newCookieValue = cookieValue + this.cookieDelimiter + catEntryIdentifier;
			}
			dojo.cookie(cookieKey, newCookieValue, {path:'/'});
			shoppingActionsJS.checkForCompare();
		} else {
			this.showWCDialogPopup('widget_product_comparison_popup');
			document.getElementById("comparebox_"+catEntryIdentifier).checked = false;
		}
	},

	addToComparePetco:function(catEntryIdentifier,imgPath){

				var cookieKey = this.cookieKeyPrefix + this.storeId;
		var cookieValue = dojo.cookie(cookieKey);
		if(cookieValue != null){
			if(cookieValue.indexOf(catEntryIdentifier) != -1 || catEntryIdentifier == null){
				MessageHelper.displayErrorMessage(storeNLS["COMPARE_ITEM_EXISTS"]);
				return;
			}
		}

				var currentNumberOfItemsInCompare = 0;
		if(cookieValue != null && cookieValue != ""){
			currentNumberOfItemsInCompare = cookieValue.split(this.cookieDelimiter).length;
		}
		if (currentNumberOfItemsInCompare < parseInt(this.maxNumberProductsAllowedToCompare)) {
			var newCookieValue = "";
			if(cookieValue == null || cookieValue == ""){
				newCookieValue = catEntryIdentifier;
			}
			else{
				newCookieValue = cookieValue + this.cookieDelimiter + catEntryIdentifier;
			}
			dojo.cookie(cookieKey, newCookieValue, {path:'/'});

						currentNumberOfItemsInCompareZone = newCookieValue.split(this.cookieDelimiter).length;
			var compareurl = dojo.byId("compareProductsURL").value;
			if(currentNumberOfItemsInCompareZone < parseInt(this.minNumberProductsAllowedToCompare)){
				document.getElementById("compare_link").setAttribute("href","#");
				document.getElementById("compare_link").style.cursor="not-allowed";
				document.getElementById("compare_link").style.color="#808080";
				$(".comparelink").tooltip("enable");
			}else{
				document.getElementById("compare_link").setAttribute("onclick",compareurl);
				document.getElementById("compare_link").style.cursor="pointer";	
				document.getElementById("compare_link").style.color="#00a3e0";
				$(".comparelink").tooltip("disable");
			}
			shoppingActionsJS.addProductstoCompare(catEntryIdentifier,imgPath);
			shoppingActionsJS.checkForCompare();

				} else {
			document.getElementById("comparebox_"+catEntryIdentifier).checked = false;
		}
		if(currentNumberOfItemsInCompare == 3)
		{
		this.addMaxCompareTooltip();
		}
	},
	addMaxCompareTooltip: function()
	{
		$("input").tooltip("enable");
		var cookieKey = this.cookieKeyPrefix + this.storeId;
		var cookieValue = dojo.cookie(cookieKey);
		var petcoCookieArray=cookieValue.split(this.cookieDelimiter);
		for	(var index = 0; index < petcoCookieArray.length; index++) {
			$("#comparebox_"+petcoCookieArray[index]).tooltip("disable");
		}
	},

	addProductstoCompare: function(catEntryIdentifier,imgPath)
	{
		var compareThumb1_div = dojo.byId("compareThumb1");	
		var compareThumb2_div = dojo.byId("compareThumb2");
		var compareThumb3_div = dojo.byId("compareThumb3");
		var compareThumb4_div = dojo.byId("compareThumb4");
		var compareThumb_div = null;
		if(compareThumb1_div.innerHTML.trim()==''){
		   compareThumb_div = compareThumb1_div;
		}else if(compareThumb2_div.innerHTML.trim()==''){
			compareThumb_div = compareThumb2_div;
		}else if(compareThumb3_div.innerHTML.trim()==''){
			compareThumb_div = compareThumb3_div;
		}else if(compareThumb4_div.innerHTML.trim()==''){
			compareThumb_div = compareThumb4_div;
		}
	    var e = document.createElement("IMG");
	    var att1=document.createAttribute("src");
	    att1.value=imgPath;
	    var att2=document.createAttribute("class");
	    att2.value="img-responsive";
		var att3=document.createAttribute("id");
		att3.value="compare_image_"+catEntryIdentifier;
	    e.setAttributeNode(att1);
	    e.setAttributeNode(att2);
	    e.setAttributeNode(att3);
	    compareThumb_div.appendChild(e);
	},

	removeFromCompare: function(catEntryIdentifier){
		var cookieKey = this.cookieKeyPrefix + this.storeId;
		var cookieValue = dojo.cookie(cookieKey);
		var currentNumberOfItemsInCompare = 0;
		if(cookieValue != null){
			if(dojo.trim(cookieValue) == ""){
				dojo.cookie(cookieKey, null, {expires: -1});
			}else{
				var cookieArray = cookieValue.split(this.cookieDelimiter);
				var newCookieValue = "";
				for(index in cookieArray){
					if(cookieArray[index] != catEntryIdentifier){
						if(newCookieValue == ""){
							newCookieValue = cookieArray[index];
						}else{
							newCookieValue = newCookieValue + this.cookieDelimiter + cookieArray[index];
						}
					}
				}
				dojo.cookie(cookieKey, newCookieValue, {path:'/'});
				currentNumberOfItemsInCompare = newCookieValue.split(this.cookieDelimiter).length;
			}

						shoppingActionsJS.checkForCompare();
		}
	},

	removeFromComparePetco: function(catEntryIdentifier,imgPath){
		var cookieKey = this.cookieKeyPrefix + this.storeId;
		var cookieValue = dojo.cookie(cookieKey);
		var petcoCookieArray=cookieValue.split(this.cookieDelimiter);
		var imgSource=[];
		var catEntryId=[];
		for	(var newIndex = 0; newIndex < petcoCookieArray.length; newIndex++) {
			catEntryId[newIndex]=petcoCookieArray[newIndex];
			imgSource[petcoCookieArray[newIndex]]=document.getElementById("compare_image_"+petcoCookieArray[newIndex]).src;
		}
		document.getElementById("compareThumb1").innerHTML='';
		document.getElementById("compareThumb2").innerHTML='';
		document.getElementById("compareThumb3").innerHTML='';
		document.getElementById("compareThumb4").innerHTML='';
		var currentNumberOfItemsInCompare = 0;
		if(cookieValue != null){
			if(dojo.trim(cookieValue) == ""){
				dojo.cookie(cookieKey, null, {expires: -1});
			}else{
				var cookieArray = cookieValue.split(this.cookieDelimiter);
				var newCookieValue = "";
				for	(var index = 0; index < cookieArray.length; index++) {
					if(cookieArray[index] != catEntryIdentifier){
						if(newCookieValue == ""){
							newCookieValue = cookieArray[index];
						}else{
							newCookieValue = newCookieValue + this.cookieDelimiter + cookieArray[index];
						}
					}
				}
				dojo.cookie(cookieKey, newCookieValue, {path:'/'});
				var compareurl = document.getElementById("compareProductsURL").value;
				currentNumberOfItemsInCompare = newCookieValue.split(this.cookieDelimiter).length;
				currentNumberOfItemsInCompareZone = newCookieValue.split(this.cookieDelimiter).length;
				if(currentNumberOfItemsInCompareZone < parseInt(this.minNumberProductsAllowedToCompare)){
					document.getElementById("compare_link").setAttribute("href","#");
					document.getElementById("compare_link").style.cursor="not-allowed";
					$(".comparelink").tooltip("enable");
					document.getElementById("compare_link").style.color="#808080";
				}else{
					document.getElementById("compare_link").setAttribute("onclick",compareurl);
					document.getElementById("compare_link").style.cursor="pointer";
					document.getElementById("compare_link").style.color="#00a3e0";
					$(".comparelink").tooltip("disable");
				}
			}

			var compareThumb1_div = dojo.byId("compareThumb1");	
			var compareThumb2_div = dojo.byId("compareThumb2");
			var compareThumb3_div = dojo.byId("compareThumb3");
			var compareThumb4_div = dojo.byId("compareThumb4");
			for(var newIndex = 0; newIndex < catEntryId.length; newIndex++) {
			if(catEntryId[newIndex]!=catEntryIdentifier){
				if(compareThumb1_div.innerHTML.trim()==''){
					var e = document.createElement("IMG");
				    var att1=document.createAttribute("src");
				    att1.value=imgSource[catEntryId[newIndex]];
				    var att2=document.createAttribute("class");
				    att2.value="img-responsive";
					var att3=document.createAttribute("id");
					att3.value="compare_image_"+catEntryId[newIndex];
				    e.setAttributeNode(att1);
				    e.setAttributeNode(att2);
				    e.setAttributeNode(att3);
				    compareThumb1_div.appendChild(e);	
				}else if(compareThumb2_div.innerHTML.trim()==''){
					var e = document.createElement("IMG");
				    var att1=document.createAttribute("src");
				    att1.value=imgSource[catEntryId[newIndex]];
				    var att2=document.createAttribute("class");
				    att2.value="img-responsive";
					var att3=document.createAttribute("id");
					att3.value="compare_image_"+catEntryId[newIndex];
				    e.setAttributeNode(att1);
				    e.setAttributeNode(att2);
				    e.setAttributeNode(att3);
				    compareThumb2_div.appendChild(e);	
				}else if(compareThumb3_div.innerHTML.trim()==''){
					var e = document.createElement("IMG");
				    var att1=document.createAttribute("src");
				    att1.value=imgSource[catEntryId[newIndex]];
				    var att2=document.createAttribute("class");
				    att2.value="img-responsive";
					var att3=document.createAttribute("id");
					att3.value="compare_image_"+catEntryId[newIndex];
				    e.setAttributeNode(att1);
				    e.setAttributeNode(att2);
				    e.setAttributeNode(att3);
				    compareThumb3_div.appendChild(e);	
				}else if(compareThumb4_div.innerHTML.trim()==''){
					var e = document.createElement("IMG");
				    var att1=document.createAttribute("src");
				    att1.value=imgSource[catEntryId[newIndex]];
				    var att2=document.createAttribute("class");
				    att2.value="img-responsive";
					var att3=document.createAttribute("id");
					att3.value="compare_image_"+catEntryId[newIndex];
				    e.setAttributeNode(att1);
				    e.setAttributeNode(att2);
				    e.setAttributeNode(att3);
				    compareThumb4_div.appendChild(e);	
				}

					}
			}
			shoppingActionsJS.checkForCompare();
		}
	},

	compareProducts:function(categoryIds){
		var url = "CompareProductsDisplayView?storeId=" + this.storeId + "&catalogId=" + this.catalogId + "&langId=" + this.langId + "&compareReturnName=" + this.compareReturnName + "&searchTerm="+ this.searchTerm;

				if('' != categoryIds.top_category){
			url = url + "&top_category=" + categoryIds.top_category;
		}
		if('' != categoryIds.parent_category_rn){
			url = url + "&parent_category_rn=" + categoryIds.parent_category_rn;
		}
		if('' != categoryIds.categoryId){
			url = url + "&categoryId=" + categoryIds.categoryId;
		}

				var cookieKey = this.cookieKeyPrefix + this.storeId;
		var cookieValue = dojo.cookie(cookieKey);
		if(cookieValue != null && dojo.trim(cookieValue) != ""){
			url = url + "&catentryId=" + cookieValue;
		}
		var returnUrl = location.href;
		if(returnUrl.indexOf("?") == -1){
			returnUrl = returnUrl + "?fromPage=compare";
		} else if(returnUrl.indexOf("fromPage=compare") == -1){
			returnUrl = returnUrl + "&fromPage=compare";
		}
		url = url + "&returnUrl=" + encodeURIComponent(returnUrl);
		location.href = getAbsoluteURL() + url;
		var sku = "";
		var catenlist = cookieValue.split(this.cookieDelimiter);
				for(var i = 0; i < catenlist.length; i++) {
					if (sku == ""){
							if(document.getElementById('sku_'+catenlist[i])== "undefined" || document.getElementById('sku_'+catenlist[i])== null){
								sku = sku +'catEntryID_'+catenlist[i];
							} else {
								sku = sku + document.getElementById('sku_'+catenlist[i]).value;
							}

														} else {
							if(document.getElementById('sku_'+catenlist[i])== "undefined" || document.getElementById('sku_'+catenlist[i])== null){
								sku = sku +'|'+'catEntryID_'+catenlist[i];
							} else {
								sku = sku+'|'+document.getElementById('sku_'+catenlist[i]).value;
							}
						}
				    }

					if (sku!= null || sku != "undefined") {
		    var eventJson = {"conversion_event_id":"Product Compare",
							"conversion_category_id":"Product Compare",
							"conversion_action_type":"2",
							"product_sku": sku};
			pushEvent(eventJson);
			}
	},


	setProductQuantity: function(catalogEntryType, catalogEntryId, quantity, price){
		var productDetails = null;
		if(this.productList[catalogEntryId]){
			productDetails = this.productList[catalogEntryId];
		} else {
			productDetails = new Object();
			this.productList[catalogEntryId] = productDetails;
			productDetails.baseItemId = catalogEntryId;
			if("item" == catalogEntryType){
				productDetails.id = catalogEntryId;
			} else {
				productDetails.id = 0;
			}
		}
		productDetails.quantity = quantity;
		dojo.topic.publish("Quantity_Changed", dojo.toJson(productDetails));

				productDetails.price = dojo.number.parse(price);
	},

	quantityChanged: function(catalogEntryId, quantity){
		if(this.productList[catalogEntryId]){
			var productDetails = this.productList[catalogEntryId];
			productDetails.quantity = dojo.trim(quantity);
			dojo.topic.publish("Quantity_Changed", dojo.toJson(productDetails));

			if(MerchandisingAssociationJS != null){
				if(MerchandisingAssociationJS.baseItemParams != null){
					if(MerchandisingAssociationJS.baseItemParams.type=='BundleBean'){
						for(idx=0;idx<MerchandisingAssociationJS.baseItemParams.components.length;idx++){
							if(catalogEntryId == MerchandisingAssociationJS.baseItemParams.components[idx].productId || catalogEntryId == MerchandisingAssociationJS.baseItemParams.components[idx].id){
								MerchandisingAssociationJS.baseItemParams.components[idx].quantity = productDetails.quantity;
							}
						}
					}
				}
			}			
		}
	},

	setPriceInProductList: function(catalogEntryId, price){
		var productDetails = this.productList[catalogEntryId];
		if(productDetails){
			productDetails.price = price;
		}
	},

	 selectBundleItemSwatch: function(catalogEntryId, swatchName, swatchValue, doNotDisable){
		if(dojo.hasClass("swatch_" + catalogEntryId + "_" + swatchName + "_" + swatchValue, "color_swatch_disabled")){
			return;
		}
		if (dojo.byId("entitledItem_"+catalogEntryId)!=null) {
			var entitledItemJSON;
			var currentSwatchkey = swatchName + "_" +swatchValue;
			entitledItemJSON = dojo.fromJson(dojo.byId("entitledItem_"+catalogEntryId).innerHTML);
			var validSwatchArr = new Array();
			for(idx in entitledItemJSON){
				var validItem = false;
				var entitledItem = entitledItemJSON[idx];
				for(attribute in entitledItem.Attributes){

										if(currentSwatchkey == attribute){
						validItem = true;
						break;
					}
				}
				if(validItem){
					for(attribute in entitledItem.Attributes){
						var currentSwatch = attribute.substring(0, attribute.lastIndexOf("_"));
						if(currentSwatch != doNotDisable && currentSwatch != swatchName){
							validSwatchArr.push(attribute);
						}
					}
				}
			}

						var swatchesDisabled = new Array();
			var selectedSwatches = new Array();
			for(idx in entitledItemJSON){
				var entitledItem = entitledItemJSON[idx];
				for(attribute in entitledItem.Attributes){
					var currentSwatch = attribute.substring(0, attribute.lastIndexOf("_"));
					if(currentSwatch != doNotDisable && currentSwatch != swatchName){
						var swatchId = "swatch_" + catalogEntryId +"_" + attribute;
						var swatchLinkId = swatchId.replace("swatch_","swatch_link_");
						if(dojo.indexOf(validSwatchArr, attribute) > -1){
							if(!dojo.hasClass(swatchId,"color_swatch_selected")){
								dojo.byId(swatchId).className = "color_swatch";
								dojo.byId(swatchId).src = dojo.byId(swatchId).src.replace("_disabled.png","_enabled.png");

								dojo.byId(swatchLinkId).title = dojo.byId(swatchId).alt;
								document.getElementById(swatchLinkId).setAttribute("aria-disabled", "false");
							}
						} else if(dojo.indexOf(swatchesDisabled, attribute) == -1){
							swatchesDisabled.push(attribute);
							if(dojo.hasClass(swatchId,"color_swatch_selected")){
								selectedSwatches.push(swatchId);
							}
							dojo.byId(swatchId).className = "color_swatch_disabled";
							dojo.byId(swatchId).src = dojo.byId(swatchId).src.replace("_enabled.png","_disabled.png");

							var titleText = storeNLS["INV_ATTR_UNAVAILABLE"];
							var altText = dojo.byId(swatchId).alt;

							dojo.byId(swatchLinkId).title = dojo.string.substitute(titleText,{0: altText});
							document.getElementById(swatchLinkId).setAttribute("aria-disabled", "true");
						}
					}
					if (document.getElementById("swatch_link_" + catalogEntryId +"_" + attribute) != null) {
						document.getElementById("swatch_link_" + catalogEntryId +"_" + attribute).setAttribute("aria-checked", "false");
					}
				}
			}

						for(idx in selectedSwatches){
				var selectedSwatch = selectedSwatches[idx];
				var idSelector = selectedSwatch.substring(0, selectedSwatch.lastIndexOf("_"));
				var swatchSelected = false;
				dojo.query("[id^='" + idSelector + "']").forEach(function(node, index, arr){
					if(!swatchSelected && dojo.hasClass(node,"color_swatch")){
						var values = node.id.split("_");
						shoppingActionsJS.selectBundleItemSwatch(values[1],values[2],values[3], doNotDisable);
						shoppingActionsJS.setSelectedAttributeOfProduct(values[1],values[2],values[3],false);
						swatchSelected = true;
					}
				});
			}
		}

				if (dojo.byId("swatch_selection_" + catalogEntryId + "_" + swatchName).style.display == "none") {
			dojo.byId("swatch_selection_" + catalogEntryId + "_" + swatchName).style.display = "inline";
		}
		dojo.byId("swatch_selection_" + catalogEntryId + "_" + swatchName).innerHTML = swatchValue;

				var swatchItem = "swatch_" + catalogEntryId + "_" + swatchName + "_";
		var swatchItemLink = "swatch_link_" + catalogEntryId + "_" + swatchName + "_";

				dojo.query("img[id^='" + swatchItem + "']").forEach(function(node, index, arr){
			if(dojo.hasClass(node, "color_swatch_disabled")){
				dojo.removeClass(node, "color_swatch")
			} else {
				dojo.addClass(node, "color_swatch");
			}
			dojo.removeClass(node, "color_swatch_selected");
		});

				dojo.byId(swatchItem + swatchValue).className = "color_swatch_selected";
		document.getElementById(swatchItemLink + swatchValue).setAttribute("aria-checked", "true");

				this.setSelectedAttributeOfProduct(catalogEntryId, swatchName, swatchValue,false);
		this.changeBundleItemImage(catalogEntryId, swatchName, swatchValue, "productThumbNailImage_" + catalogEntryId);

			},

		changeBundleItemImage: function(catalogEntryId, swatchAttrName, swatchAttrValue, skuImageId){
		var entitledItemId = "entitledItem_" + catalogEntryId;
		if (dojo.byId(entitledItemId)!=null) {
			 entitledItemJSON = eval('('+ dojo.byId(entitledItemId).innerHTML +')');
		}

		this.setEntitledItems(entitledItemJSON);

		var skuImage = null;
		var imageArr = shoppingActionsJS.getImageForBundleItem(catalogEntryId);
		if(imageArr != null){
			skuImage = imageArr[1];
		}

				if(skuImageId != undefined){
			this.setSKUImageId(skuImageId);
		}

				if(skuImage != null){
			if(dojo.byId(this.skuImageId) != null){
				document.getElementById(this.skuImageId).src = skuImage;	
				if(document.getElementById("ProductInfoImage_"+catalogEntryId) != null){
					document.getElementById("ProductInfoImage_"+catalogEntryId).value = skuImage;
				}
			}
		} else {
			var imageFound = false;
			for (x in this.entitledItems) {
				var Attributes = this.entitledItems[x].Attributes;
				var itemImage = this.entitledItems[x].ItemThumbnailImage;

								for(y in Attributes){
					var index = y.indexOf("_");
					var entitledSwatchName = y.substring(0, index);
					var entitledSwatchValue = y.substring(index+1);	

										if (entitledSwatchName == swatchAttrName && entitledSwatchValue == swatchAttrValue) {
						document.getElementById(this.skuImageId).src = itemImage;		
						if(document.getElementById("ProductInfoImage_"+catalogEntryId) != null){
							document.getElementById("ProductInfoImage_"+catalogEntryId).value = itemImage;
						}
						imageFound = true;
						break;
					}
				}

								if(imageFound){
					break;
				}
			}
		}	
	},

		getImageForBundleItem: function(entitledItemId){
		var attributeArray = [];
		var selectedAttributes = this.selectedProducts[entitledItemId];
		for(attribute in selectedAttributes){
			attributeArray.push(attribute + "_" + selectedAttributes[attribute]);
		}
		return this.resolveImageForSKU(attributeArray);
	},

	checkForCompare: function() {
		require(["dojo/_base/array", "dojo/cookie", "dojo/on", "dojo/query"], function(array, cookie, on, query) {
			var cookieValues = cookie(shoppingActionsJS.cookieKeyPrefix + shoppingActionsJS.storeId);
			cookieValues = (cookieValues ? cookieValues.split(shoppingActionsJS.cookieDelimiter) : []);
			var labels = query(".compareCheckboxLabels > label");
			query(".compare_target").forEach(function(div) {
				var checkbox = query("input[type=\"checkbox\"]", div)[0];
				checkbox.checked = (array.indexOf(cookieValues, checkbox.value) != -1);
				var state = (checkbox.checked ? (cookieValues.length > 1 ? 2 : 1) : 0);
				div.setAttribute("data-state", state.toString());
				var label = query("label[for=\"" + checkbox.id + "\"]", div)[0];

							});
		});
	},

	replaceItemAjaxHelper : function(catalogEntryId,qty,removeOrderItemId,addressId,shipModeId,physicalStoreId){

				var params = [];
		params.storeId = WCParamJS.storeId;
		params.catalogId = WCParamJS.catalogId;
		params.langId = WCParamJS.langId;
		params.orderItemId	= removeOrderItemId;
		params.orderId = ".";
		if(CheckoutHelperJS.shoppingCartPage){	
			params.calculationUsage = "-1,-2,-5,-6,-7";
		}else{
			params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
		}

		var params2 = [];
		params2.storeId = WCParamJS.storeId;
		params2.catalogId = WCParamJS.catalogId;
		params2.langId = WCParamJS.langId;
		params2.catEntryId	= catalogEntryId;
		params2.quantity = qty;
		params2.orderId = ".";
		params2.callToODM = "true";
		if(CheckoutHelperJS.shoppingCartPage){	
			params2.calculationUsage = "-1,-2,-5,-6,-7";
		}else{
			params2.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
		}

		var params3 = [];
		params3.storeId = WCParamJS.storeId;
		params3.catalogId = WCParamJS.catalogId;
		params3.langId = WCParamJS.langId;
		params3.orderId = ".";
		if(CheckoutHelperJS.shoppingCartPage){	
			params3.calculationUsage = "-1,-2,-5,-6,-7";
		}else{
			params3.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
		}


								var shipInfoUpdateNeeded = false;
		var orderItemReqd = true;
		if(addressId != null && addressId != ""){
			params3.addressId = addressId;
		}
		if(shipModeId != null && shipModeId != ""){
			params3.shipModeId = shipModeId;
		}
		if(physicalStoreId != null && physicalStoreId != ""){
			params3.physicalStoreId = physicalStoreId;
			orderItemReqd = false;
		}
		if(params3.shipModeId != null && (params3.addressId != null || params3.physicalStoreId != null)){
			shipInfoUpdateNeeded = true;
		}

				if(orderItemReqd){
			params3.allocate="***";
			params3.backorder="***";
			params3.remerge="***";
			params3.check="*n";
		}

		wc.service.declare({
			id: "AjaxReplaceItem",
			actionId: "AjaxReplaceItem",
			url: "AjaxOrderChangeServiceItemDelete",
			formId: ""

			,successHandler: function(serviceResponse) {
				if(!shipInfoUpdateNeeded){
					wc.service.invoke("AjaxAddOrderItem", params2);
				}
				else{
					wc.service.invoke("AjaxAddOrderItemTemp", params2);
				}
			}

			,failureHandler: function(serviceResponse) {
				if (serviceResponse.errorMessage) {
							 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
					  } else {
							 if (serviceResponse.errorMessageKey) {
									MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
							 }
					  }
					  cursor_clear();
			}

		});

		wc.service.declare({
			id: "AjaxAddOrderItemTemp",
			actionId: "AjaxAddOrderItemTemp",
			url: "AjaxOrderChangeServiceItemAdd",
			formId: ""

			,successHandler: function(serviceResponse) {
				if(orderItemReqd){
					params3.orderItemId = serviceResponse.orderItemId[0];
				}

								MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_ADDED"]);

				wc.service.invoke("OrderItemAddressShipMethodUpdate", params3);
			}

			,failureHandler: function(serviceResponse) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		});

		if(!submitRequest()){
			return;
		}   
		cursor_wait();
		wc.service.invoke("AjaxReplaceItem",params);
	},

	customizeDynamicKit : function(catEntryIdentifier, quantity, customParams)
	{
		var params = [];
		params.storeId		= this.storeId;
		params.catalogId	= this.catalogId;
		params.langId		= this.langId;
		params.catEntryId	= catEntryIdentifier;
		params.quantity		= quantity;

				if(!isPositiveInteger(quantity)){
			MessageHelper.displayErrorMessage(storeNLS['QUANTITY_INPUT_ERROR']);
			return;
		}

		var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
		if (contractIdElements != null && contractIdElements != "undefined") {
			for (i=0; i<contractIdElements.length; i++) {
				if (contractIdElements[i].checked) {
					params.contractId = contractIdElements[i].value;
					break;
				}
			}
		}

		if(customParams != null && customParams != 'undefined'){
			for(i in customParams){
				params[i] = customParams[i];
			}
		}

		if(!submitRequest()){
			return;
		}   
		cursor_wait();

				var configureURL = "ConfigureView";
		var i =0;
		for(param in params){
			configureURL += ((i++ == 0)? "?" : "&") + param + "=" + params[param];
		}
		document.location.href = getAbsoluteURL() + configureURL;
	},

	addPayPalPaymentInstructions: function()
	{
		var params = [];
		var form;			
		if(document.PayPalForm && dojo.query('form[name="PayPalForm"]').length > 1){
			form = dojo.query('form[name="PayPalForm"]')[0];
		}else{
			form = document.PayPalForm;
		}
		params["storeId"] = form.storeId.value;
		params["catalogId"] = form.catalogId.value;
		params["langId"] = form.langId.value;
		params["merchant"] = form.payPalMerchant.value;
		params["payMethodId"] = form.payPalMethodId.value;
		params["piAmount"] = form.PayPalOrderTotal.value;
		params["orderId"] = form.orderId.value;

				if(dojo.query('input[id^="repeat-delivery-checkbox"]:checked').length > 0){
			localStorageHelper.set("payPalBA","true");
		}
		else if(localStorageHelper.get('payPalBA')!=  null){
			localStorageHelper.remove('payPalBA');
		}

				if(!submitRequest()){
			return;
		}
		cursor_wait();			
		wc.service.invoke('AjaxAddPayPalInstructionToThisOrder',params);
	},

	deletePrevAddNewPayPalInstructions: function(){
		var params = [];

				params["piId"] = new Array();

				var ids = document.getElementById("payPalPID").value;
		if (ids.indexOf(",") >= 0){
			var splitId = ids.split(",");
			for(var i = 0; i < splitId.length; i++)			{
			   params["piId"].push(splitId[i]);
			}	
		}
		else{
			params["piId"].push(ids);
		}
		var form;			
		if(document.PayPalForm && dojo.query('form[name="PayPalForm"]').length > 1){
			form = dojo.query('form[name="PayPalForm"]')[0];
		}else{
			form = document.PayPalForm;
		}
		params["storeId"] = form.storeId.value;
		params["catalogId"] = form.catalogId.value;
		params["langId"] = form.langId.value;
		params.orderId = ".";

				cursor_wait();
		wc.service.invoke('AjaxDeletePayPalPaymentInstructionFromThisOrder',params);
	},

		changeDescription: function(entitledItemId,attributeValue){
		var catalogEntryId = this.getCatalogEntryId(entitledItemId);
		if(attributeValue!=''){
			if(document.getElementById("donationId")!=null && document.getElementById("donationId")!='undefined'){
				document.getElementById("donationId").innerHTML = attributeValue;
			}
		}

			},
	refreshCurrentPage: function(isShoppingCart){
		if(isShoppingCart == 'ShopCart'){
			document.location.href = document.location.href;
		}
	},
	callSearchClickEvent: function(catentryId,searchType){
		try{
			 var cartEventDetails = {};	
			 if(searchType == 'Search'){
				 cartEventDetails["event_name"] = "search_product_result_click";
			 }else{
				 cartEventDetails["event_name"] = "link_tracking";
			 }
			 cartEventDetails["product_parent_id"] = catentryId;
			if(dojo.byId("prd_id_"+catentryId) != undefined && dojo.byId("prd_id_"+catentryId) != null)
				cartEventDetails["product_parent_sku"] = dojo.byId("prd_id_"+catentryId).value;
			if(dojo.byId("prd_name_"+catentryId) != undefined && dojo.byId("prd_name_"+catentryId) != null)
				cartEventDetails["product_name"] = dojo.byId("prd_name_"+catentryId).value;			
			var ids = "product_tile_val_"+catentryId;
			pushEvent(cartEventDetails,ids);

					}catch(err){
			console.log("issue in tagging "+err);
		}
	},
	handleRdAddonSelectionChange: function(){

				$("#add2RDOrderBtn").removeClass("disabled");
		$("#add2RDordermsg").text("");
		$("#add2RDordermsg").removeClass("show");

			}

	}

dojo.topic.subscribe("ProductInfo_Reset", shoppingActionsJS.resetProductAddedList);

require(["dojo/on", "dojo/has", "dojo/_base/sniff", "dojo/domReady!"], function(on, has) {
	if (has("ie") < 9) {
		on(document, ".compare_target > input[type=\"checkbox\"]:click", function(event) {
			this.blur();
			this.focus();
		});
	}
});
